import {ActionTypes} from './actions';
import {TEmailContextType, TEmailReducerType, TEmailStateType} from './types';
import {renderDefault} from '../utils/common';
import {IMessagesValues} from '../EmailDialog';
import {replaceTitlesWithIds} from '../utils/treeActions';

const updateContext = (context: TEmailContextType) => {
    return (
        stateName?: keyof TEmailStateType,
        payloadValue?: (typeof context.states)[keyof TEmailStateType]
    ) => ({...context, states: {...context.states, [stateName]: payloadValue}});
};

const resetContext = (context: TEmailContextType, messagesValues: IMessagesValues) => () => ({
    ...context.handlers,
    states: {
        ...renderDefault(messagesValues).states,
        emailEditor: context.states.emailEditor
    }
});

export const emailReducer: TEmailReducerType = (state, action, messagesValues) => {
    const update = updateContext(state);
    const reset = resetContext(state, messagesValues);

    const language = state.states.language;
    const states = state.states;

    switch (action.type) {
        case ActionTypes.OPEN_EMAILEDITOR:
            return {...state};

        case ActionTypes.CLOSE_EMAILEDITOR:
            return reset();

        case ActionTypes.SAVE_EMAILEDITOR:
            return null;

        case ActionTypes.PERSONALIZE_UPDATE:
            return update('personalizeState', action.payload?.personalizeState);

        case ActionTypes.HYPERLINK_STATES_UPDATE:
            return update('hyperlinkState', {
                ...state.states.hyperlinkState,
                ...action.payload?.hyperlinkStates
            });

        case ActionTypes.HYPERLINK_ACTIVE_UPDATE:
            return update('hyperlinkState', {
                ...state.states.hyperlinkState,
                active: action.payload?.isActive
            });

        case ActionTypes.IMAGE_UPDATE:
            return update('imageState', action.payload?.imageState);

        case ActionTypes.LANGUAGE_UPDATE:
            return update('language', action.payload?.language);

        case ActionTypes.UPDATE_EMAIL_EDITOR:
            return update('emailEditor', action.payload?.editor);

        case ActionTypes.UPDATE_EMAIL_HTML:
            const emailHtml = action.payload?.emailHtml;

            return {
                ...state,
                states: {
                    ...states,
                    [language]: {
                        ...states[language],
                        emailHtml
                    }
                }
            };

        case ActionTypes.UPDATE_EMAIL_SUBJECT:
            const subject = action.payload?.subject;

            return {
                ...state,
                states: {
                    ...states,
                    [language]: {
                        ...states[language],
                        editorSubject: subject
                    }
                }
            };

        case ActionTypes.UPDATE_EMAIL_SUBJECT_IDS:
            const subjectWithIds = replaceTitlesWithIds(
                action.payload?.subject,
                action.payload?.treeValues
            );

            return {
                ...state,
                states: {
                    ...states,
                    [language]: {
                        ...states[language],
                        editorSubjectIds: subjectWithIds
                    }
                }
            };

        default:
            return state;
    }
};
